export default class BaseEvent {

    constructor(gameState, ui, narrator) {
        this.ui = ui;
        this.gameState = gameState;
        this.narrator = narrator;
        this.end = this.end.bind(this);

    }

    apply(gameState) {
        gameState.paused = true;
        this.gameState = gameState;
        this.enter(gameState);
    }

    schedule(eventKls, time) {
        this.narrator.schedule(eventKls, time);
        this.end();
    }

    end() {
        this.ended = true;
        this.ui.hideWindow(() => {
            this.gameState.paused = false;
            this.narrator.onEnd(this);
        });
    }

    update() {

    }



}


// WEBPACK FOOTER //
// ./src/states/events/base_event.js